/**
 * Site footer component
 */
export const Footer = () => (
  <footer>
   
  </footer>
);
